import { call, put } from "redux-saga/effects";
import { WalletResponse } from "reduxStore/dataTypes";
import { walletFailure, walletSuccess } from "../reducers/walletReducer";
import { fetchWalletDetails } from "services/apiService";

function* walletSaga(): Generator<any, void, WalletResponse | any> {
  try {
    const response = yield call(fetchWalletDetails);
    yield put(walletSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(walletFailure(error.response));
    } else {
      yield put(walletFailure(error.message));
    }
  }
}

export default walletSaga;
